import {
  OrderModificationActionSchema,
  type OrderModificationAction as GeneratedOrderModificationAction
} from '~/services/api/generated'

// Mirrors backend App\Enums\OrderModificationAction

export type OrderModificationAction = GeneratedOrderModificationAction

export const OrderModificationAction = {
  APPROVE: OrderModificationActionSchema.enum.approve,
  REJECT: OrderModificationActionSchema.enum.reject
} satisfies Record<string, GeneratedOrderModificationAction>

export const OrderModificationActionValues: readonly GeneratedOrderModificationAction[] = [
  OrderModificationActionSchema.enum.approve,
  OrderModificationActionSchema.enum.reject
]
